<template>
  <div class="basic">
    <Form ref="formInline" :model="formInline" style="width: 100%" :rules="ruleInline" label-position="top" @on-validate="getvalidate">
      <div class="basic-header">
        <p>- 企业基本信息 -</p>
      </div>
      <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
        <!-- 公司名称 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="12">
            <div style="display: flex">
              <FormItem label="公司名称（中文）" prop="companyName">
                <Input type="text" v-model="formInline.companyName" style="width: 270px; margin-right: 10px" placeholder="请输入企业名称（必须和营业执照一致）" />
              </FormItem>
              <FormItem label="公司简称（2~5个字）" prop="companyNameShort">
                <Input type="text" placeholder="请输入公司简称" v-model="formInline.companyNameShort" style="width: 270px; margin-right: 10px" />
              </FormItem>
            </div>
            </Col>
            <Col span="12">
            <div style="display: flex">
              <FormItem label="统一社会信用代码" prop="creditCode" id="creditCode">
                <Input type="text" placeholder="请输入统一社会信用代码" v-model="formInline.creditCode" style="width: 270px" />
              </FormItem>
            </div>
            </Col>
            <Col span="12">
            <div style="display: flex">
              <FormItem label="英文名称" prop="companyNameEn">
                <Input type="text" placeholder="请输入英文名称" v-model="formInline.companyNameEn" style="width: 270px; margin-right: 10px" />
              </FormItem>
              <FormItem label="英文简称" prop="companyNameShortEn">
                <Input type="text" placeholder="请输入英文简称" v-model="formInline.companyNameShortEn" style="width: 270px; margin-right: 10px" />
              </FormItem>
            </div>
            </Col>
          </Row>
        </div>
        <!-- 公司地址 -->
        <div class="basic-name">
          <Row :gutter="10">
            <Col span="12">
            <FormItem label="公司地址" required prop="addresss">
              <div style="width:550px">
                <mFormAddress v-model="formInline.addresss" @change="validAddresss"></mFormAddress>
              </div>
            </FormItem>
            </Col>

            <Col span="10">
            <div style="padding: 0 0 3px 0;"></div>
            <div style="display: flex">
              <FormItem prop="address" id="address" label="详细地址">
                <Input type="text" placeholder="请输入详细地址" v-model="formInline.address" style="width: 410px; margin-right: 10px" />
              </FormItem>
              <FormItem prop="postcode" id="postcode" label="邮编">
                <Input type="text" placeholder="请输入邮编" v-model="formInline.postcode" style="width: 130px" />
              </FormItem>
            </div>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="展会联系人" required> </FormItem>
      </div>
      <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
        <div class="basic-links">
          <Row :gutter="10">
            <Col span="12">
            <div style="display: flex">
              <FormItem label="姓名" prop="linkMan">
                <Input type="text" placeholder="请输入姓名" v-model="formInline.linkMan" style="width: 270px; margin-right: 10px" />
              </FormItem>
              <FormItem label="职务" prop="linkTitle">
                <Input type="text" placeholder="请输入职务" v-model="formInline.linkTitle" style="width: 270px" />
              </FormItem>
            </div>
            </Col>
            <Col span="12">
            <div style="display: flex">
              <FormItem label="手机" prop="linkMob">
                <Input  placeholder="请输入手机号" v-model="formInline.linkMob" style="width: 270px; margin-right: 10px" />
              </FormItem>
              <FormItem label="邮箱" prop="linkEmail">
                <Input type="text" placeholder="请输入邮箱" v-model="formInline.linkEmail" style="width: 270px" />
              </FormItem>
            </div>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
            <Row>
              <Col span="12">
              <FormItem label="座机电话" :required="false">
                <div style="display: flex">
                  <FormItem prop="linkCode">
                    <Input v-model="formInline.linkCode" style="width: 90px; margin-right: 10px" placeholder="请输入区号" />
                  </FormItem>
                  一 &nbsp
                  <FormItem prop="linkTelephone">
                    <Input  v-model="formInline.linkTelephone" style="width: 140px; margin-right: 10px" placeholder="电话号码" />
                  </FormItem>
                </div>
                <p style="line-height: 1;font-size: 12px;color: #808080; position: relative;top: -12px;">
                  示例：010-6343 0880
                </p>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="QQ" prop="linkQQ" style="position: relative;margin-left: -10px;">
                <Input placeholder="展会联系人QQ" v-model="formInline.linkQQ" style="width: 270px" />
              </FormItem>
              </Col>
            </Row>
            </Col>
            <Col span="12">
            <FormItem label="微信" prop="linkWeChat">
              <Input type="text" placeholder="请输入微信" v-model="formInline.linkWeChat" style="width: 270px" />
            </FormItem>
            </Col>
          </Row>
        </div>
      </div>
      <!-- <div class="handle-box">
        <Button :loading="loading" @click="handleSubmit('formInline')" class="handle-box-btn" type="primary">保存并提交</Button>
      </div> -->

    </Form>
  </div>
</template>

<script>
import mFormAddress from "@components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data () {
    const that = this;
    const companyAddressValid = (rule, value, callback) => {
      if (that.formInline.addresss.country && that.formInline.addresss.country === '中国') { // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          callback(new Error('省份为空'));
        } else if (!that.formInline.addresss.city) {
          callback(new Error('城市为空'));
        } else {
          callback();
        }
      } else {
        if (that.formInline.addresss.country) {
          callback();
        } else {
          callback(new Error('地址为空'));
        }
      }
    };

    // 判断中文
    const zhValid = (rule, value, callback) => {
      if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        callback();
      } else {
        callback(new Error('公司名称格式有误'));
      }
    };
    // 判断英文
    const enValid = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (/^(?!\s*$)[A-Za-z0-9.,_\-\&\(\)\（）\s-]+$/.test(value)) {
          callback();
        } else {
          callback(new Error('英文名称格式有误'));
        }
      }
    };

    const validEmail = (rule, value, callback) => {
      if (value) {
        if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
          callback();
        } else {
          callback("请输入正确的邮箱地址");
        }
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameShort: "", // 公司简称
        companyNameEn: "",// 公司英文名称
        companyNameShortEn: "",// 公司英文简称
        creditCode: "", // 统一社会信用代码 
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县 
        },
        postcode: "",

        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",

      },
      formInline2: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameShort: "连战", // 公司简称
        companyNameEn: "lianzhan",// 公司英文名称
        companyNameShortEn: "lianzhan",// 公司英文名称
        creditCode: "91310118MA1JM12CX7", // 统一社会信用代码 
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县 
        },
        postcode: "201803",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "8888888", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          // { validator: zhValid, trigger: "blur" }
        ],
        companyNameShort: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
          { type: 'string', min: 2, max: 5, message: '公司简称长度在2到5个字符', trigger: 'blur' }
        ],
        companyNameEn: [
          { validator: enValid, trigger: "blur" }
        ],
        creditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
          ...validator.CreditCode,
        ],
        addresss: [{
          required: true,
          validator: companyAddressValid, trigger: "blur"
        }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],

        // 展会联系人
        linkMan: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        linkTitle: [{ required: true, message: "请输入职务", trigger: "blur" }],
        linkMob: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          ...validator.phone
        ],
        linkEmail: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { validator: validEmail, trigger: 'blur' }
        ],

      },
      defaultList: [],
      uploadList: [],
      uploadName: "",


      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框 

      countryList: [],
      provinceArr: [],
      citiesArr: [],
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
    userId () {
      return this.$route.query.userId;
    },
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),
    getvalidate (prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm('formInline');
      let errTxt = '';
      if (!valid) {
        errTxt = this.validateList[0] ? this.validateList[0].error : '请完善表单'
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        this.validateList = [];
      }
      let formValue = {
        companyName: form.companyName, // 公司名称
        companyNameShort: form.companyNameShort, // 公司简称
        companyNameEn: form.companyNameEn,// 公司英文名称
        companyNameShortEn: form.companyNameShortEn,// 公司英文名称
        unifiedCode: form.creditCode, // 统一社会信用代码 
        address: form.address, // 详细地址 
        country: form.addresss.country,
        province: form.addresss.province,
        city: form.addresss.city,

        postcode: form.postcode,

        // 展会联系人
        linkMan: form.linkMan,
        linkTitle: form.linkTitle,
        linkTelephone: form.linkTelephone,
        linkEmail: form.linkEmail,
        linkCode: form.linkCode, // 区号
        linkMob: form.linkMob, // 电话号码
        linkQQ: form.linkQQ,
        linkWeChat: form.linkWeChat,
      }
      return new Promise((resolve, reject) => {
        resolve({ valid: valid, form: formValue })
      });
    },
    validAddresss () {
      // this.$refs['formInline'].validateField('addresss', (valid) => {
      //   console.log("addresss", valid);
      // });
    }
  },
};
</script>

<style scoped lang='scss'>
.basic {
  /deep/ {
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-upload-select {
      display: flex;
    }

    .ivu-radio-checked .ivu-radio-inner {
      border-color: #4f65ae !important;
    }

    .ivu-radio-inner:after {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-switch-checked {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
</style>
